import { Component, Inject, type OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { type BasicDocumentDTOExtended, type SaleContractFeedbackDTO, VehicleDocumentsService } from '../../../../services/vehicle-documents.service'
import {
  FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule
} from '@angular/forms'
import { NGXLogger } from 'ngx-logger'
import { SharedService } from '../../../../services/shared.service'

import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
interface DialogData {
  offer: BasicDocumentDTOExtended
  action: 'accept' | 'decline'
}
@Component({
  selector: 'customer-portal-app-accept-decline-offer-popup',
  standalone: true,
  templateUrl: './accept-decline-offer-popup.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule
  ]
})
export class AcceptDeclineOfferPopupComponent implements OnInit {
  saveButtonColor = 'secondary'
  saving = false

  maxLength = 512 // max length in mail comment

  form = new FormGroup({
    comment: new FormControl<string | null>(null, [
      Validators.maxLength(this.maxLength)
    ])
  })

  constructor (
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<AcceptDeclineOfferPopupComponent>,
    public sharedService: SharedService,
    private readonly vehicleDocumentsService: VehicleDocumentsService,
    private readonly logger: NGXLogger

  ) {}

  onActionConfirm (): void {
    this.saving = true

    const body: SaleContractFeedbackDTO = {
      id: Number(this.data.offer.id), // its number in interface
      comment: this.form.controls.comment.value,
      mailOfferState: this.data.action === 'accept' ? 'ACCEPTED' : 'DECLINED'
    }
    this.vehicleDocumentsService.acceptDeclineOffer(body).subscribe({
      next: data => {
        this.dialogRef.close({ success: true })
      },
      error: error => {
        this.logger.log(error)
        this.dialogRef.close({ success: false })
      }
    })
  }

  ngOnInit (): void {
    this.saveButtonColor = this.data.action === 'accept' ? 'secondary' : 'warn'
  }
}
